import { combineReducers } from "redux";

import { reducer } from "../../router/auth/reducer";
import { baseApi, baseAuthApi } from "../../service/baseApi";
import { dataGroupModalState } from "./state/dataGroupModal/dataGroupModalState";
import { dynamicPropertiesLoadingState } from "./state/dynamicPropertiesLoading/dynamicPropertiesLoadingState";
import { languageState } from "./state/language/languageState";
import { notificationsState } from "./state/notifications/notificationsState";
import { tabState } from "./state/tabs/tabState";

/**
 * Gets root reducer of application.
 *
 * Module reducers are added manually. Hardcoded names are used, otherwise
 * code suggestion for state does not work well.
 *
 * Any unhandled error from reducers will be processed by top level error handling and ErrorPage will be displayed.
 */
export const getRootReducer = () =>
    combineReducers({
        notifications: notificationsState.reducer,
        language: languageState.reducer,
        dataGroup: dataGroupModalState.reducer,
        dynamicPropertiesLoading: dynamicPropertiesLoadingState.reducer,
        activeTab: tabState.reducer,
        auth: reducer,
        [baseApi.reducerPath]: baseApi.reducer,
        [baseAuthApi.reducerPath]: baseAuthApi.reducer,
    });
